module.exports = __webpack_public_path__ + "static/img/doc.876251d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chat/images/chat_files/doc.png
// module id = uuyi
// module chunks = 1